import React from 'react';
import URL from 'url-parse';

import Translation from '@swf/components/Translation/Translation';
import AccountIcon from '@swf/core/assets/icons/account-selected.svg';
import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';

import { TXTWCL_PokerStars_My_Account } from './AccountRamRedirect.messages.json';
import styles from './AccountRamRedirect.scss';

const AccountRamRedirect: React.FC = () => {
  const starsWebPoker = useResolver(ResolverTag.StarsWebPoker);
  const url = new URL(starsWebPoker, true);
  url.query.wc2l = 'starsReward';

  return (
    <a href={url.toString()} className={styles.container}>
      <AccountIcon className={styles.icon} />
      <span className={styles.text}>
        <Translation {...TXTWCL_PokerStars_My_Account} />
      </span>
    </a>
  );
};
export default AccountRamRedirect;
